<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn padbtn">
          <div class="col-4" v-if="canCreate()">
            <button class="btn btn-secondary btn-fg custom-shadow-btn" @click="openModal('create')">
              <i class="fa fa-plus"></i>
              Agregar Perfil
            </button>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-12 text-center">
            <h6 class="text-muted">Perfiles Activos</h6>
          </div>
        </div>
        <div v-if="canIndex()">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-6">
                <el-select
                  class="select-default mb-3"
                  v-model="pagination.perPage"
                  placeholder="Por pagina">
                  <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <div class="mr-1 pull-right" v-if="canPDF()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/pdf.svg"
                    alt="pdf"
                    v-tooltip="'Exportar en formato PDF'"
                    @click="exportPDF('perfiles', 'Perfiles', 'a4', tableData, tableColumnsAll, 1)">
                </div>
                <div class="mr-1 pull-right" v-if="canExcel()">
                    <img
                      class="img-exports"
                      src="/static/img/icons/docs/xls.svg"
                      alt="xls"
                      v-tooltip="'Exportar en formato XLSX'"
                      @click="exportExcel('perfiles', tableData, tableColumnsAll, 1)">
                </div>
                <div class="mr-1 pull-right" v-if="canCSV()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/csv.svg"
                    alt="csv"
                    v-tooltip="'Exportar en formato CSV'"
                    @click="exportCSV('perfiles', tableData, tableColumnsAll, 1)">
                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <el-input
                class="mb-3"
                placeholder="Buscar registros"
                v-model="searchQuery"
                aria-controls="datatables"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      border
                      ref="tableRole">
              <el-table-column type="index" width="65"></el-table-column>
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
              <el-table-column label="Modulos" minWidth="200" prop="modules[0].name">
                <template slot-scope="scope">
                  <el-badge class="custom-el-badge__content item" v-if="scope.row.modules.length > 0"
                  :hidden="(scope.row.modules.length == 1) ? true : false"
                  :value="200" :max="scope.row.modules.length-1">
                    <el-button plain type="primary" size="small">{{scope.row.modules[0].name_module}}, ...  </el-button>
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="120"
                fixed="right"
                label="Acciones">
                <template slot-scope="props">
                  <a v-if="canShow()" v-tooltip.top-center="'Ver'" class="btn-info btn-simple btn-link"
                     @click="handleView(props.$index, props.row)">
                    <i class="fa fa-eye"></i></a>
                  <a v-if="canUpdate()" v-tooltip.top-center="'Editar'" class="btn-warning btn-simple btn-link"
                     @click="handleEdit(props.$index, props.row)"><i
                    class="fa fa-edit"></i></a>
                  <a v-if="canDelete()" v-tooltip.top-center="'Borrar'" class="btn-danger btn-simple btn-link"
                     @click="handleDelete(props.$index, props.row)"><i class="fa fa-times"></i></a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <el-dialog v-if="canCreate() || canUpdate()"
      :title="title"
      :visible.sync="modals.create">
      <form>
        <div class="row">
          <div class="col-12">
            <fg-input
            type="text"
            label="Nombre *"
            v-model="roleForm.name"
            v-validate="modelValidations.name"
            name="nombre"
            :error="getError('nombre')"
            :disabled="disabledField">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Modulos *</label>
            <el-select  multiple :class="selectClass" class="select_modules"
                        v-model="roleForm.modules"
                        filterable placeholder="Seleccione uno o varios Modulos">
              <el-option v-for="option in modules"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name_module"
                          :key="option.name_module"
                          >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row" v-if="errorAlert ">
          <div class="col-lg-12"><br>
            <el-alert
              :title="errorAlert"
              type="error">
            </el-alert>
          </div>
        </div>
      </form>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-danger" @click="closeModal('create')">Cancelar</button>&nbsp;
        <button class="btn btn-success" @click="validateForm">Confirmar</button>
      </span>
    </el-dialog>
    <el-dialog v-if="canShow()"
      :title="title"
      :visible.sync="modals.read">
        <p>A continuación encontrarás toda la información asociada al registro seleccionado.</p>
        <div class="card" v-if="rowData">
          <div class="card-body">
            <table class="table">
              <tbody v-if="rowData">
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6><b>Nombre:</b></h6>
                    {{rowData.name}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6 class="custom-margin-h6-table"><b>Modulos:</b></h6>
                    <template v-for="(modul, index) in rowData.modules">
                      <el-tag :key="modul.id"
                        size="small"
                        type="success"
                        :closable="false"
                        :close-transition="false">
                          {{modul.name_module}}
                      </el-tag>
                      <br :key="index+'Index'" v-if="(((index+1) % 3) == 0)"/>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
            <div class="card-footer footer-date-at" v-if="rowData">
              <p class="text-muted"><small>Creado el: {{rowData.created_at}}</small></p>
            </div>
        </div>
    </el-dialog>
  </div>
</div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import showSwalAlert from 'src/util/alerts'
  import table from './roleTable'
  import moment from 'moment';

  export default {
    data () {
      return {
        roleForm: {
          name: null,
          modules: [],
        },
        modelValidations: {
          name: {
            required: true,
          }
        },
        modals: {
          create: false,
        },
        modules: null,
        tableColumns: table[0],
        tableColumnsAll: table,
      }
    },
    mixins: [mixinMasters, mixinPermissions],
    methods: {
      openModal (name) {
        if (name == 'create'){
          this.title = 'Agregar un Perfil',
          this.$validator.reset();
          this.roleForm = {
            name: null,
            modules: []
          }
          this.disabledField = false
        }
        this.modals[name] = true
      },
      validateForm(name){
        this.$validator.validateAll().then(isValid => {
          if(isValid) {
            if( this.roleForm.modules.length != 0) this.addEditRole()
            else {
              this.selectClass = 'select-danger'
              this.errorAlert = 'Debe seleccionar uno o mas modulos'
              setTimeout(()=>{
                this.selectClass = "select-primary"
                this.errorAlert = null
              }, 5000)
            }
          }
        })
      },
      handleView (index, row) {
        this.rowData = Object.assign({}, row)
        this.rowData.created_at = moment(String(this.rowData.created_at)).format('MM/DD/YYYY hh:mm:ss')
        this.title = 'Perfil '+row.name
        this.modals['read'] = true
      },
      handleEdit (index, row) {
        this.roleForm = Object.assign({}, row)
        this.roleForm.modules = row.modules_ids
        this.title = 'Editar Perfil '+row.name
        this.roleForm.route = 'roles'
        this.errors.clear();
        this.disabledField = true
        this.modals['create'] = true
      },
      handleDelete (index, row) {
        this.roleForm = Object.assign({}, row)
        this.roleForm.modules = row.modules_ids
        showSwalAlert('Perfil', 'delete', true, null, 'perfil: '+row.name).then((result) => {
          if (result.value) this.deleteRole()
        })
      },
      addEditRole(){
        this.$emit('cotentLoading', true)
        if (this.roleForm.route == 'roles'){
          this.updateMaster(this.roleForm)
            .then((response) => this.modifyTable(1, this.roleForm.id, response))
            .catch((error) => {
              if(error.response.data.errors.name){
                this.errorAlert = error.response.data.errors.name[0]
                setTimeout(()=>{
                  this.errorAlert = null
                  this.$emit('cotentLoading')
                }, 5000)
              }
            })
        } else {
          this.roleForm.route = 'roles'
          this.saveMaster(this.roleForm).then((response) => {
            this.modifyTable(0, this.roleForm.id, response)
          }).catch((error) => {
            this.roleForm.route = null
            if(error.response.data.errors.name){
              this.errorAlert = error.response.data.errors.name[0]
              setTimeout(()=>{
                this.errorAlert = null
                this.$emit('cotentLoading')
              }, 5000)
            }
          })
        }
      },
      deleteRole(){
        this.$emit('cotentLoading', true)
        this.roleForm.route = 'roles'
        this.destroyMaster(this.roleForm)
          .then((response) => this.modifyTable(2, this.roleForm.id, response))
          .catch((error) => this.showMessageErrors(error))
      },
    },
    created(){
      if(this.canIndex()){
        this.getMasters('roles').then((response) => {
          this.tableData = response.data.data
          this.searchFuse(['name', 'modules_names'])
          this.$emit('cotentLoading')
        }).catch((error) => this.showMessageErrors(error))
        this.getMasters('modules/index').then((response) => this.modules = response.data.data).catch((error) => this.showMessageErrors(error))
      }
    }
  }
</script>
<style>
</style>
